<script>
    // import { text } from 'svelte/internal';
    import Navbar from '../navbar/navbar.svelte';
    import Footer from '../landing_page/footer.svelte';
    import NavbarMenu from '../navbar/navbar_menu.svelte';
    import FooterMbl from '../programs/mobile_reuse-section/footer_mbl.svelte';
    const {title} = rpcjs.props;
    title.set('Pledge');
    const pledgeText = [
        {
            text: 'I will promote freedom at all costs.',
        },
        {
            text: 'I will do everything in my power to drive, build and pursue progress and change.',
        },
        {
            text: 'My brand , my network, and my reputation are paramount.',
        },
        {
            text: 'I will set positive examples for others to emulate.',
        },
        {
            text: 'I will instill good habits in myself. I will take care of myself.',
        },
        {
            text: 'I will  fail and fail again until I succeed.',
        },
        {
            text: 'I will  explain the world with gusto and enthusiasm.',
        },
        {
            text: 'I will treat people well.',
        },
        {
            text: 'I will make short-term sacrifice for long term success.',
        },
        {
            text: 'I will pursue fairness, openness, health and fun with all that I encounter. Mostly fun.',
        },
        {
            text: 'I will keep my word.',
        },
        {
            text: 'I will try my best to make reparations for my digressions.',
        },
    ];
    const clause = [
        {
            image: 'images/pledge/black_swan.png',
            heading: 'The Black Swan Clause',
            paragraph:
                'I am bound to this oath unless in my travels I determine '+
                'that the oath has somehow missed something important and extraordinary.',
        },
        {
            image: 'images/pledge/evangelism.png',
            heading: 'The Evangelism Clause',
            paragraph:
                'I will promote and add to the ongoing success of Draper University, '+
                'its students, its faculty. I will help prepare the next generation of Superheroes.*',
        },
        {
            image: 'images/pledge/superhero.png',
            heading: 'The SuperheroClause',
            paragraph:
                'I will accept the lifelong obligation to hone my Superhero powers, '+
                'and apply those Superhero powers to the good of the universe.',
        },
    ];
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<section>
    <div class="desktop">
        <Navbar />
    </div>
    <div class="mobile bg-img">
        <NavbarMenu backgroundColor="transparent" stroke="black" />
        <div
            style="font-size: 8.333vw;
            color: white;
            font-weight: 600;
            text-align: center;
            padding-top: 125.056vw;
            text-transform: uppercase;
        "
        >
            <p>The Pledge</p>
        </div>
    </div>
    <div class="desktop">
        <div style="display: flex;">
            <div class="left-div">
                <div
                    style="font-size: 4.630vw; font-weight:600; margin-left:3.373vw;margin-top: 1.5vw;text-transform: uppercase;"
                >
                    <p>The Pledge</p>
                </div>
                <ul class="points">
                    {#each pledgeText as data}
                        <li style="">
                            <p
                                style="width:33.201vw; padding-left:2.116vw; font-size:1.058vw; line-height: 1.325vw;margin-bottom: 0.512vw;"
                            >
                                {data.text}
                            </p>
                        </li>
                    {/each}
                </ul>
            </div>
            <div
                style="width: 39.46vw; margin-top:13.360vw;margin-left:10.351vw;"
            >
                <img src="images/pledge/pledge_image.png" alt="" width="100%" height="84%"/>
            </div>
        </div>
        <div
            style="display: flex; margin-left: 9.5vw;
        width: 80vw;
        justify-content: space-between;"
        >
            {#each clause as text}
                <div class="clause">
                    <div class="clause-img">
                        <img src={text.image} alt="" width="100%" />
                    </div>
                    <div
                        style="font-size: 1.653vw; font-weight:600;margin-top: 2.844vw;
                text-align: center;"
                    >
                        <p>{text.heading}</p>
                    </div>
                    <div
                        style="font-size: 1.190vw; width:21.230vw;    text-align: center;
                margin: auto;padding-top: 1.511vw;"
                    >
                        <p>{text.paragraph}</p>
                    </div>
                </div>
            {/each}
        </div>
        <div style="font-size: 1.190vw;margin-top:3.968vw;text-align: center;">
            <p>
                * The Evangelism Clause is not a requirement unless you are an
                alum, or just want to support us.
            </p>
        </div>
        <div
            style=" text-align: center;
        margin-top: 3vw;"
        >
            <a style="text-decoration:none;text-decoration:none;"
            href="/program_hero"
             class="btn">Learn More About Hero Training</a 
                >
        </div>
        <div
            style="display: flex;justify-content: space-between;margin-bottom:4vw;"
        >
            <div class="quote-div1">
                <div
                    style="width: 5.065vw;
                    margin-left: 4.903vw;
                    margin-top: 7.562vw;"
                >
                    <img src="images/pledge/quote1.svg" alt="" width="100%" />
                </div>
                <div
                    style="font-size: 1.984vw; font-weight:600; width:28.638vw; color:white;margin-left:9.15vw;    line-height: 3.042vw;    font-style: italic;"
                >
                    <p>My brand, my network & my reputation are paramount.</p>
                </div>
                <div
                    style="width: 5.065vw;
                margin-left: 31.25vw;"
                >
                    <img src="images/pledge/quote2.svg" alt="" width="100%" />
                </div>
            </div>
            <div class="quote-div2">
                <div
                    style="width: 5.065vw;
                    margin-left: 5.898vw;
                    margin-top: 6.372vw;"
                >
                    <img src="images/pledge/quote3.svg" alt="" width="100%" />
                </div>
                <div
                    style="font-size: 1.984vw; font-weight:600; width:29.638vw;margin-top: 1.411vw;
                     color:black;margin-left:8vw;    line-height: 3.042vw;font-style: italic;text-align: center;"
                >
                    <p>
                        I will make short term sacrifices for long term success.
                    </p>
                </div>
                <div
                    style="width: 5.065vw;
                margin-left: 32.75vw;"
                >
                    <img src="images/pledge/quote4.svg" alt="" width="100%" />
                </div>
            </div>
        </div>
        <Footer />
    </div>




    <div class="mobile">
        <div>
            <ul class="points">
                {#each pledgeText as data}
                    <li style="">
                        <p
                            style="width: 78.056vw;
                            padding-left: 2.116vw;
                            font-size: 4.444vw;
                            margin-top: 9.600vw;"
                        >
                            {data.text}
                        </p>
                    </li>
                {/each}
            </ul>
        </div>
        <div style="margin-top: 25.981vw;">
            {#each clause as text}
                <div class="clause-mbl">
                    <div style="display: flex;">
                        <div class="clause-img-mbl">
                            <img src={text.image} alt="" width="100%" />
                        </div>
                        <div
                            style="font-size: 5.556vw;
                            font-weight: 600;
                            padding-top: 16.167vw;
                            margin-left: 3vw;
                            color:rgba(0, 32, 75, 1);"
                        >
                            <p>{text.heading}</p>
                        </div>
                    </div>
                    <div
                        style="font-size: 3.889vw;
                        width: 76.389vw;
                        padding-top: 5.112vw;
                        margin: auto;
                        text-align: center;
                        color:rgba(0, 32, 75, 1);
                        line-height: 6.944vw;
                    "
                    >
                        <p>
                            {text.paragraph}
                        </p>
                    </div>
                </div>
            {/each}
        </div>
        <div
            style="font-size: 3.889vw; width: 78.056vw; margin:auto; margin-top:14.724vw;text-align: center;"
        >
            <p>
                * The Evangelism Clause is not a requirement unless you are an
                alum, or just want to support us.
            </p>
        </div>
        <div
            style=" text-align: center;
            margin-top: 8.972vw;
            "
        >
            <button class="btn-mbl">Learn More About Hero Training</button>
        </div>
        <div class="quote-div1-mbl">
            <div
                style="width: 10.419vw;
                margin-left: 8.894vw;
                padding-top: 12vw;"
            >
                <img src="images/pledge/quote1.svg" alt="" width="100%" />
            </div>
            <div
                style="font-size: 5.556vw; font-weight:600; width:72.500vw; color:white;margin-left:13vw;text-align:center;"
            >
                <p>My brand, my network & my reputation are paramount</p>
            </div>
            <div
                style="width: 10.419vw;
            margin-left: 68.5vw;
            margin-top: -3vw;"
            >
                <img src="images/pledge/quote2.svg" alt="" width="100%" />
            </div>
        </div>
        <div style="width: 100vw;background-color:white;
        padding: 5.276vw 0 10vw 0 ;
    ">
            <div class="quote-div2-mbl">
                <div
                    style="width: 10.419vw;
                    margin-left: 8.894vw;
                    padding-top: 12vw;"
                >
                    <img src="images/pledge/quote3.svg" alt="" width="100%" />
                </div>
                <div
                    style="font-size: 5.556vw; font-weight:600; width:72.500vw; color:black;margin-left:13vw;text-align:center;"
                >
                    <p>I will make short term sacrifices for long term success</p>
                </div>
                <div
                    style="width: 10.419vw;
                    margin-left: 65.5vw;
                    margin-top: -3vw;"
                >
                    <img src="images/pledge/quote4.svg" alt="" width="100%" />
                </div>
            </div>
        </div>
        <div>
            <FooterMbl />
        </div>
    </div>
    
</section>

<style>
    p{
        padding: 0;
        margin: 0;
    }
    .left-div {
        width: 47.09vw;
        height: fit-content;
        position: relative;
        border: 0.198vw solid #7cc1ff;
        margin-left: 4.101vw;
        margin-top: 15.939vw;
        border-left: none;
        border-top-right-radius: 1.5vw;
        border-bottom-right-radius: 1.5vw;
    }
    .left-div::after {
        content: "";
        height: 1.918vw;
        width: 1.918vw;
        background-color: #f7e05f;
        border-radius: 50%;
        position: absolute;
        top: -1vw;
        left: 3vw;
    }
    ul {
        padding: 0;
        margin: 0;
        margin-left: 8.384vw;
        margin-bottom: 4vw;
    }
    ul li::marker {
        color: #7cc1ff;
        font-size: 1.58vw;
    }
    .clause {
        width: 24.918vw;
        height: 28.283vw;
        background: #ecf6fc;
        border-radius: 1.984vw;
    }
    .clause-mbl {
        width: 91.111vw;
        height: 65.056vw;
        background: #ecf6fc;
        border-radius: 8.333vw;
        margin: auto;
        margin-top: 5.556vw;
    }
    .clause-img {
        width: 5.423vw;
        margin: auto;
        margin-top: 3.175vw;
    }
    .clause-img-mbl {
        width: 12.5vw;
    margin-left: 6.667vw;
    padding-top: 13.167vw;
    }
    .btn {
        background-color: #3c74c0;
        color: white;
        font-size: 1.19vw;
        font-weight: 500;
        border-radius: 1.984vw;
        border: none;
        width: 23.942vw;
        height: 4.167vw;
        padding-top: 1.15vw;
    }
    .btn-mbl {
        background-color: #3c74c0;
        color: white;
        font-size: 3.333vw;
        font-weight: 500;
        width: 61.666vw;
        border-radius: 4.984vw;
        height: 11.112vw;
        border: none;
    }
    .quote-div1 {
        width: 47.619vw;
        height: 28.392vw;
        background: #3c74c0;
        border-top-right-radius: 1.5vw;
        border-bottom-right-radius: 1.5vw;
        margin-top: 9.59vw;
    }
    .quote-div2 {
        width: 47.619vw;
        height: 28.392vw;
        background: #f7e05f;
        border-top-left-radius: 1.5vw;
        border-bottom-left-radius: 1.5vw;
        margin-top: 9.59vw;
    }
    .quote-div1-mbl {
        width: 95.833vw;
        height: 66.667vw;
        background: #00204b;
        border-top-right-radius: 9vw;
        border-bottom-right-radius: 9vw;
        margin-top: 29.724vw;
    }
    .quote-div2-mbl {
        width: 95.833vw;
        height: 66.667vw;
        background: #f7e05f;
        border-top-left-radius: 9vw;
        border-bottom-left-radius: 9vw;
        margin-left:auto;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    .bg-img {
        background-image: url("images/pledge/pledge_back_mbl.png");
        height: 142.222vw;
        background-repeat: no-repeat;
        background-size: cover;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        ul {
            padding: 0;
            margin: 0;
            margin-left: 13.384vw;
            margin-top: 12vw;
        }
        ul li::marker {
            color: #7cc1ff;
            font-size: 5.222vw;
        }
    }
</style>
